// extracted by mini-css-extract-plugin
module.exports = {"container":"searcher_container__clcaP","icon":"searcher_icon__T_LWC"};